export default __webpack_public_path__ + "static/media/chartres_cathedral.58bb4582.jpg";